import {
  FormControl,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  TableContainer,
  TableCell,
  TableRow,
  Table,
  TableHead,
  TableBody,
  Paper,
  Fab,
  Grid,
} from "@mui/material";

import { Add, DeleteRounded, Warning } from "@mui/icons-material";

import PulseLoading from "../../components/PulseLoading/PulseLoading.component";
import { ProductsSelect } from "../../components/CustomSelect/ProductsSelect.component";

import { CustomTooltip } from "../../components/CustomTooltip/CustomTooltip.component";
import { CustomButton } from "../../components/CustomButton/CustomButton.component";
import { customStyle } from "../../components/CustomSelect/useStyles";

const TransactionViewProducts = ({
  classes,
  isSku,
  items,
  productsLoading,
  selectedSkus,
  skusOption,
  handleSkuSelect,
  selectedProducts,
  productsOption,
  handleProductSelect,
  onQuantityChangedHandler,
  onItemPriceChangedHandler,
  onRemoveItem,
  dialogMsg,
  doubleCheck,
  proceedBigQuantity,
  onAddItem,
}) => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TableContainer className="products" component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center" className={classes.tableHead}>
                    {isSku ? "Product Code" : "Product Name"}
                  </TableCell>
                  <TableCell align="center" className={classes.tableHead}>
                    Qty
                  </TableCell>
                  <TableCell align="center" className={classes.tableHead}>
                    Unit Price
                  </TableCell>
                  <TableCell align="center" className={classes.tableHead}>
                    Total Unit Price
                  </TableCell>
                  <TableCell
                    align="center"
                    className={classes.tableHead}
                  ></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {items &&
                  items.length > 0 &&
                  items.map((item, idx) => {
                    const totalUnitPrice = item.quantity * item.item_price;
                    return (
                      <TableRow key={idx}>
                        <TableCell align="left">
                          {productsLoading ? (
                            <PulseLoading />
                          ) : (
                            <>
                              {isSku ? (
                                <ProductsSelect
                                  key={idx} // Ensure each select has a unique key
                                  value={selectedSkus[idx]}
                                  options={skusOption}
                                  isClearable={true}
                                  onChange={(selectedOption) =>
                                    handleSkuSelect(idx, selectedOption)
                                  }
                                  customStyles={customStyle}
                                  index={idx} // Pass the index for sorting
                                  selectedSkus={selectedSkus} // Pass the selected SKUs
                                />
                              ) : (
                                <ProductsSelect
                                  key={idx} // Ensure each select has a unique key
                                  value={selectedProducts[idx]}
                                  options={productsOption}
                                  isClearable={true}
                                  onChange={(selectedOption) =>
                                    handleProductSelect(idx, selectedOption)
                                  }
                                  customStyles={customStyle}
                                  index={idx} // Pass the index for sorting
                                  selectedProducts={selectedProducts} // Pass the selected SKUs
                                />
                              )}
                            </>
                          )}
                        </TableCell>
                        <TableCell align="center">
                          <FormControl className="TransactionView__item">
                            <TextField
                              value={item.quantity}
                              type="number"
                              onChange={(e) => onQuantityChangedHandler(e, idx)}
                              InputProps={{
                                inputProps: {
                                  min: 1,
                                  style: { textAlign: "right", width: "80px" },
                                },
                              }}
                            />
                          </FormControl>
                        </TableCell>
                        <TableCell align="center">
                          <FormControl className="TransactionView__item">
                            <TextField
                              value={item.item_price}
                              type="number"
                              onChange={(e) =>
                                onItemPriceChangedHandler(e, idx)
                              }
                              inputProps={{
                                style: { textAlign: "right", width: "90px" },
                              }}
                            />
                          </FormControl>
                        </TableCell>
                        <TableCell align="right">
                          ₱{totalUnitPrice.toFixed(2)}
                        </TableCell>
                        <TableCell align="right">
                          <CustomTooltip
                            label={"Remove"}
                            icon={
                              <DeleteRounded
                                className={classes.deleteIcon}
                                onClick={() => onRemoveItem(idx)}
                              />
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <Dialog open={dialogMsg !== ""}>
        <DialogContent
          dangerouslySetInnerHTML={{ __html: dialogMsg }}
        ></DialogContent>
        <DialogActions>
          <CustomButton
            onClick={doubleCheck}
            color="secondary"
            title="Double Check"
          />

          <CustomButton
            onClick={proceedBigQuantity}
            startIcon={<Warning />}
            title="PROCEED"
          />
        </DialogActions>
      </Dialog>
      <CustomTooltip
        label={"Add Product"}
        icon={
          <Fab
            color="primary"
            aria-label="add"
            className={classes.muifab}
            onClick={onAddItem}
          >
            <Add />
          </Fab>
        }
      />
    </>
  );
};

export default TransactionViewProducts;
